import { useState } from "react";
import { uploadFile } from "./ftpService";
import { ArrowUpTrayIcon, ArrowRightOnRectangleIcon } from "@heroicons/react/24/solid";
import { useNavigate } from "react-router-dom";

export default function UploadFile({ fetchFiles }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const navigate = useNavigate();

  const handleUpload = async () => {
    if (!selectedFile) return;
    await uploadFile(selectedFile);
    fetchFiles();
    setSelectedFile(null);
  };

  const handleDisconnect = () => {
    // Efface les credentials avant de rediriger
    localStorage.removeItem("ftpHost");
    localStorage.removeItem("ftpUsername");
    localStorage.removeItem("ftpPassword");

    navigate("/ftp-connect");
  };

  return (
    <div className="flex flex-col md:flex-row justify-between items-center mt-4 bg-white p-4 rounded-lg shadow-md border border-gray-200">
      {/* 📂 Upload Section */}
      <div className="flex flex-col md:flex-row items-center space-y-3 md:space-x-4 md:space-y-0 w-full md:w-auto">
        <label className="flex items-center space-x-2 bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-lg cursor-pointer shadow-sm border border-gray-300">
          <ArrowUpTrayIcon className="w-5 h-5 text-gray-600" />
          <span className="text-sm">Choisir un fichier</span>
          <input
            type="file"
            className="hidden"
            onChange={(e) => setSelectedFile(e.target.files[0])}
          />
        </label>

        <button
          onClick={handleUpload}
          disabled={!selectedFile}
          className={`px-4 py-2 text-sm font-medium rounded-lg flex items-center space-x-2 shadow-md 
            ${selectedFile ? "bg-green-500 hover:bg-green-600 text-white" : "bg-gray-300 text-gray-500 cursor-not-allowed"}`}
        >
          <ArrowUpTrayIcon className="w-5 h-5" />
          <span>Uploader</span>
        </button>
      </div>

      {/* 🔌 Bouton Se Déconnecter */}
      <button
        onClick={handleDisconnect}
        className="mt-4 md:mt-0 px-4 py-2 text-sm font-medium bg-red-500 hover:bg-red-600 text-white rounded-lg flex items-center space-x-2 shadow-md transition-all"
      >
        <ArrowRightOnRectangleIcon className="w-5 h-5" />
        <span>Se déconnecter</span>
      </button>
    </div>
  );
}
